var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5935 0.27738C12.7712 0.0997735 13.0121 0 13.2633 0C13.5145 0 13.7554 0.0997735 13.9331 0.27738L17.7226 4.0669C17.9002 4.24456 18 4.48548 18 4.73669C18 4.9879 17.9002 5.22883 17.7226 5.40649L5.40669 17.7224C5.22907 17.9001 4.98814 17.9999 4.7369 18H0.947379C0.696118 18 0.455149 17.9002 0.277481 17.7225C0.0998128 17.5449 0 17.3039 0 17.0526V13.2631C5.36571e-05 13.0119 0.0999017 12.7709 0.277582 12.5933L9.75137 3.11952L12.5935 0.27738ZM10.4212 5.12891L1.89476 13.6553V16.1052H4.34468L12.8711 7.57883L10.4212 5.12891ZM14.2107 6.23924L15.7132 4.73669L13.2633 2.28677L11.7608 3.78931L14.2107 6.23924Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.e016b77dca5405e46311ddfde2537f40.svg";
export { ForwardRef as ReactComponent };